__turbopack_context__.v({
  "backButton": "_3_kNcq_backButton",
  "body": "_3_kNcq_body",
  "button": "_3_kNcq_button",
  "closeButton": "_3_kNcq_closeButton",
  "closeButtonIcon": "_3_kNcq_closeButtonIcon",
  "controls": "_3_kNcq_controls",
  "description": "_3_kNcq_description",
  "footer": "_3_kNcq_footer",
  "header": "_3_kNcq_header",
  "headerDescription": "_3_kNcq_headerDescription",
  "hideXs": "_3_kNcq_hideXs",
  "iconBack": "_3_kNcq_iconBack",
  "infoClass": "_3_kNcq_infoClass",
  "isDisabled": "_3_kNcq_isDisabled",
  "popup": "_3_kNcq_popup",
  "popupContainer": "_3_kNcq_popupContainer",
  "popupTitle": "_3_kNcq_popupTitle",
  "row": "_3_kNcq_row",
  "search": "_3_kNcq_search",
  "selectAll": "_3_kNcq_selectAll",
  "selectAllContainer": "_3_kNcq_selectAllContainer",
  "selectedCount": "_3_kNcq_selectedCount",
  "selectedWords": "_3_kNcq_selectedWords",
  "separator": "_3_kNcq_separator",
  "showXs": "_3_kNcq_showXs",
  "subTitle": "_3_kNcq_subTitle",
  "tag": "_3_kNcq_tag",
  "trashIcon": "_3_kNcq_trashIcon",
  "withBackground": "_3_kNcq_withBackground",
  "wordListControl": "_3_kNcq_wordListControl",
  "wordListControlButton": "_3_kNcq_wordListControlButton",
  "wordListControlDown": "_3_kNcq_wordListControlDown",
  "wordListControlUp": "_3_kNcq_wordListControlUp",
  "wordListWrap": "_3_kNcq_wordListWrap",
  "words": "_3_kNcq_words",
});
